module.exports = __webpack_public_path__ + "static/img/monogenic-03.de5e872.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/monogenicdisease/monogenic-03.png
// module id = GgYo
// module chunks = 0